// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__FQ5Su","row":"styles_row__1tEfE"};